var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ padding: '1rem' }),attrs:{"role":"main","data-id":"meeting detail"}},[_c('Detail',{attrs:{"showButtons":true,"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }